<template>
  <!-- 去电响铃 -->
  <div id="outing-call-view" v-show="isOutingCallViewVisible">
    <div class="peer-info">
      <img
        class="peer-pho"
        src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-7/1658388218664/pho.png"
      />
      <!-- 业务方根据实际呼叫用户进行替换 -->
      <p class="peer-name">{{ callInfoName }}</p>
      <p class="outing-call-tip">设备正在响铃中，请不要挂断...</p>
    </div>
    <div class="op-btns">
      <div class="out-call-mode">
        <img :src="callModeIcon" @click="changeMode()" alt="Call Mode Icon" />
        <p class="out-call-mode-txt">{{ callModeText }}</p>
      </div>
      <div>
        <img
          @click="dropCall()"
          src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433175110/reject.png"
        />
        <p style="color: #e24940">挂断</p>
      </div>
    </div>
  </div>
</template>

<script>
import { changeMode, dropCall } from '@/utils/duerService';
import waves from '@/directive/waves'; // waves directive
export default {
  directives: { waves },
  data() {
    return {
      callModeIcon: '',
      callModeText: '',
      callInfoName: '',
      isOutingCallViewVisible: false,
    };
  },
  methods: {
    changeMode() {
      changeMode();
    },
    dropCall() {
      dropCall();
    },
    // 显示isOutingCallViewVisible弹窗
    makingCallShow() {
      this.isOutingCallViewVisible = true;
    },
    // 隐藏isOutingCallViewVisible弹窗
    makingCallHide() {
      this.isOutingCallViewVisible = false;
    },
    callInfo(callInfoName, callModeText, callModeIcon) {
      this.callInfoName = callInfoName;
      this.callModeText = callModeText;
      this.callModeIcon = callModeIcon;
    },
  },
};
</script>
<style>
#login-form,
#device-form {
  width: 500px;
  margin: 20px auto 20px;
}
.usr-info {
  text-align: center;
}
.usr-pho {
  margin-top: 35px;
  width: 120px;
  height: 120px;
}
.usr-name {
  margin-top: 10px;
  font-weight: 500;
  font-size: 30px;
  line-height: 42px;
  color: #1a1a1a;
}
.incoming-call-tip {
  font-size: 16px;
  line-height: 22px;
  color: #666666;
}
.op-btns {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.op-btns img {
  width: 80px;
  height: 80px;
  margin: 24px 80px;
  cursor: pointer;
}
.op-txt {
  line-height: 20px;
  text-align: center;
}
#outing-call-view,
#call-view {
  position: fixed;
  width: 50%;
  height: 55%;
  right: 22%;
  top: 22%;
  z-index: 10052;
  background: #080808cf;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
#outing-call-view .op-btns {
  margin-top: 50px;
}
.peer-pho {
  width: 104px;
  height: 104px;
  margin-top: 50px;
}
.peer-name {
  font-size: 60px;
  line-height: 86px;
}
.outing-call-tip {
  font-size: 42px;
  line-height: 60px;
  color: rgba(225, 225, 225, 0.5);
}
#call-view .op-btns {
  position: absolute;
  bottom: 50px;
}
.main-view {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background-image: url('https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661773897681/audioBg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fff;
  text-align: center;
}
.main-view video {
  width: 100%;
  object-fit: fill;
}
.main-view .audio-name {
  margin-top: 100px;
  font-size: 62px;
  line-height: 87px;
}
.main-view .audio-call {
  font-size: 36px;
  line-height: 50px;
  color: rgba(225, 225, 225, 0.5);
  margin-top: 17px;
}
.main-view .audio-tip-wrap {
  position: absolute;
  top: 0;
}
.sub-view {
  width: 320px;
  height: 192px;
  position: absolute;
  left: 48px;
  top: 48px;
  background-image: url('https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661773897681/audioBg.png');
  background-repeat: no-repeat;
  background-size: 100%;
  color: #fff;
  z-index: 1;
}
.sub-view video {
  width: 320px;
  height: 192px;
  object-fit: fill;
}
.sub-view .audio-tip-wrap {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.sub-view .audio-name {
  font-size: 48px;
  line-height: 67px;
  max-width: 300px;
}
.sub-view .audio-call {
  font-size: 24px;
  line-height: 34px;
  text-align: right;
}
#message-alert {
  position: fixed;
  z-index: 1053;
  width: 300px;
  right: 0;
  top: 10px;
  display: none;
}
.desc-title {
  text-align: center;
  margin-bottom: 20px;
}
.modal {
  background: #c0c6d6cf;
  width: 50%;
  height: 40%;
  position: fixed;
  right: 22%;
  top: 20%;
}
</style>
